import {apiClient} from "../utils/Api";

export default class ProvinceService {

    static getList = () => {
        return apiClient.get(`/province/list`);
    };

}